<script>
import Print from '../printSetting/print'
import smallPrint from '../printSetting/smallPrint'
import HalfPrint from '../printSetting/halfPrint'
export default {
  name: 'QzPrint',
  functional: true,
  render: function(createElement, { props, data, children }) {
    let printComponent = Print
    if (props.type) {
      if (props.type.includes('8cm')) {
        printComponent = smallPrint
      } else if (['bisect', 'trisection'].some(item => props.type.includes(item))) {
        printComponent = HalfPrint
      }
    }
    return createElement(
      printComponent,
      data,
      children
    )
  }
}
</script>
